module.exports = __webpack_public_path__ + "static/media/screenshot-passivize.d0390380.png";